import {
  CloseButton as ChakraCloseButton,
  defineStyle,
  defineStyleConfig,
} from '@chakra-ui/react'

import { CloseButtonProps } from './CloseButton.types'

const toastStyleVariant = defineStyle({
  backgroundColor: 'white',
  borderRadius: '0.5rem',
  padding: '0.25rem',
  width: '2rem',
  height: '2rem',
})

export const CloseButtonStyle = defineStyleConfig({
  variants: {
    toast: toastStyleVariant,
  },
})

export default function CloseButton(props: CloseButtonProps) {
  return <ChakraCloseButton {...props} translate="no" />
}
